import React, { useEffect, useMemo, useState } from 'react';
import { ECommerceService } from 'services/eCommerce/eCommerce';
import styles from 'assets/jss/material-dashboard-pro-react/components/gobizTableStyle';
import { makeStyles } from '@material-ui/core';
import PriceCell from 'components/ServicesTables/common/cells/PriceCell';
import { finalize } from 'rxjs/operators';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import CustomCircularProgress from 'components/CustomCircularProgress/CustomCircularProgress';
import { translate } from 'components/Translation';
import DOMPurify from 'dompurify';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ICustomColumnProps {
	uniqueId: string;
	prices: types.ecommerce.Price[];
}

const CustomColumn = ({ uniqueId, prices }: ICustomColumnProps) => {
	const [description, setDescription] = useState<string>('');
	const [loading, setLoading] = useState<boolean>(true);
	const classes = useStyles();

	const priceCell = useMemo(() => {
		const price = {
			offer: prices.find((singlePrice) => singlePrice.usage === 'Offer'),
			display: prices.find((singlePrice) => singlePrice.usage === 'Display'),
		};
		return (
			<PriceCell
				price={price?.display?.value || '-'}
				currency={price?.display?.currency || ''}
				perMonth
				offerPrice={price.offer}
			/>
		);
	}, [prices]);

	useEffect(() => {
		setLoading(true);
		ECommerceService.getContentById(uniqueId)
			.pipe(finalize(() => setLoading(false)))
			.subscribe(({ response }) => {
				if (response.catalogEntryView && response.catalogEntryView.length === 1) {
					setDescription(response.catalogEntryView[0].longDescription);
				}
			});
	}, [uniqueId]);

	return (
		<ConditionalRender
			show={loading}
			onTrue={() => (
				<div>
					<CustomCircularProgress text={translate('loading')} loading transparent />
				</div>
			)}
			onFalse={() => (
				<>
					<div
						className={classes.customColumnWrapper}
						dangerouslySetInnerHTML={{
							__html: DOMPurify.sanitize(description, { ALLOWED_TAGS: ['span'] }),
						}}
					/>
					<div className={classes.customColumnWrapper}>{priceCell}</div>
				</>
			)}
		/>
	);
};

export default CustomColumn;
